import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { FileDown, Play } from 'lucide-react';
export function BriefingPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen bg-[#0a1628] pt-32 pb-20 px-6" data-id="element-495">
      <div className="max-w-3xl mx-auto" data-id="element-496">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-497">
          <h1 className="text-3xl md:text-4xl font-bold text-white mb-2" data-id="element-498">
            Briefing
          </h1>
          <p className="text-white/60 text-lg" data-id="element-499">Letiště Hořovice — LKHV</p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="bg-[#0f1d35] border border-white/5 rounded-2xl p-8 md:p-12 shadow-xl" data-id="element-500">
          <div className="prose prose-invert max-w-none" data-id="element-501">
            <p className="text-lg text-white/80 leading-relaxed" data-id="element-502">
              Vážení piloti, pro svou činnost na letišti Hořovice - LKHV se
              nejprve pečlivě seznamte se všemi informacemi na této stránce.
              Použitím letiště Hořovice potvrzujete, že jste s informacemi na
              této stránce{' '}
              <span className="text-[#38bdf8] font-semibold" data-id="element-503">
                lkhv.eu/briefing
              </span>{' '}
              seznámeni.
            </p>
          </div>

          <div className="mt-10 pt-8 border-t border-white/10" data-id="element-504">
            <h3 className="text-sm font-medium text-white/50 uppercase tracking-wider mb-4" data-id="element-505">
              Dokumenty
            </h3>
            <div className="flex flex-wrap gap-3" data-id="element-506">
              <a href="https://drive.google.com/file/d/17xTGeN7IhKg96-8HwL9ocDjgCbIhQl03/view?usp=sharing" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-3 bg-[#0a1628] border border-white/10 rounded-xl px-5 py-4 hover:border-[#38bdf8]/40 hover:bg-[#0a1628]/80 transition-all group" data-id="element-507">
                <div className="flex items-center justify-center w-10 h-10 bg-red-500/15 rounded-lg" data-id="element-508">
                  <FileDown className="w-5 h-5 text-red-400" data-id="element-509" />
                </div>
                <div data-id="element-510">
                  <span className="text-white font-medium group-hover:text-[#38bdf8] transition-colors" data-id="element-511">
                    Letištní řád
                  </span>
                  <span className="block text-xs text-white/40 mt-0.5" data-id="element-512">
                    PDF dokument
                  </span>
                </div>
              </a>
              <a href="https://drive.google.com/file/d/1Ujjfy7oQOWmSqugUhhd6lVnashclR4rP/view?usp=sharing" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-3 bg-[#0a1628] border border-white/10 rounded-xl px-5 py-4 hover:border-[#38bdf8]/40 hover:bg-[#0a1628]/80 transition-all group" data-id="element-513">
                <div className="flex items-center justify-center w-10 h-10 bg-red-500/15 rounded-lg" data-id="element-514">
                  <FileDown className="w-5 h-5 text-red-400" data-id="element-515" />
                </div>
                <div data-id="element-516">
                  <span className="text-white font-medium group-hover:text-[#38bdf8] transition-colors" data-id="element-517">
                    Směrnice RADIO
                  </span>
                  <span className="block text-xs text-white/40 mt-0.5" data-id="element-518">
                    PDF dokument
                  </span>
                </div>
              </a>
              <a href="https://drive.google.com/file/d/1ezruudcBnJQMUMOmAMO5XMhlsrF2UZcu/view?usp=sharing" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-3 bg-[#0a1628] border border-white/10 rounded-xl px-5 py-4 hover:border-[#38bdf8]/40 hover:bg-[#0a1628]/80 transition-all group" data-id="element-519">
                <div className="flex items-center justify-center w-10 h-10 bg-red-500/15 rounded-lg" data-id="element-520">
                  <FileDown className="w-5 h-5 text-red-400" data-id="element-521" />
                </div>
                <div data-id="element-522">
                  <span className="text-white font-medium group-hover:text-[#38bdf8] transition-colors" data-id="element-523">
                    Bezpečnostní Program
                  </span>
                  <span className="block text-xs text-white/40 mt-0.5" data-id="element-524">
                    PDF dokument
                  </span>
                </div>
              </a>
              <a href="https://drive.google.com/file/d/1GfFB_2Izk4Bv31pk0X4_CANfHaPFxu4K/view?usp=sharing" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-3 bg-[#0a1628] border border-white/10 rounded-xl px-5 py-4 hover:border-[#38bdf8]/40 hover:bg-[#0a1628]/80 transition-all group" data-id="element-525">
                <div className="flex items-center justify-center w-10 h-10 bg-red-500/15 rounded-lg" data-id="element-526">
                  <FileDown className="w-5 h-5 text-red-400" data-id="element-527" />
                </div>
                <div data-id="element-528">
                  <span className="text-white font-medium group-hover:text-[#38bdf8] transition-colors" data-id="element-529">
                    Letištní pohotovostní plán
                  </span>
                  <span className="block text-xs text-white/40 mt-0.5" data-id="element-530">
                    PDF dokument
                  </span>
                </div>
              </a>
            </div>
          </div>

          <div className="mt-10 pt-8 border-t border-white/10" data-id="element-531">
            <h3 className="text-sm font-medium text-white/50 uppercase tracking-wider mb-4" data-id="element-532">
              Periodické zimní školení AD LKHV — 2026
            </h3>
            <div className="flex flex-wrap gap-3" data-id="element-533">
              <a href="https://drive.google.com/file/d/1vnA15nAjBr4g3xpCFCKpQ7WFZT_t3NDt/view?usp=sharing" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-3 bg-[#0a1628] border border-white/10 rounded-xl px-5 py-4 hover:border-[#38bdf8]/40 hover:bg-[#0a1628]/80 transition-all group" data-id="element-534">
                <div className="flex items-center justify-center w-10 h-10 bg-[#38bdf8]/15 rounded-lg" data-id="element-535">
                  <FileDown className="w-5 h-5 text-[#38bdf8]" data-id="element-536" />
                </div>
                <div data-id="element-537">
                  <span className="text-white font-medium group-hover:text-[#38bdf8] transition-colors" data-id="element-538">
                    Zimní školení 2026
                  </span>
                  <span className="block text-xs text-white/40 mt-0.5" data-id="element-539">
                    PDF dokument
                  </span>
                </div>
              </a>
            </div>
          </div>

          <div className="mt-10 pt-8 border-t border-white/10" data-id="element-540">
            <h3 className="text-sm font-medium text-white/50 uppercase tracking-wider mb-4" data-id="element-541">
              Rozbor leteckých nehod
            </h3>
            <div className="flex flex-wrap gap-3" data-id="element-542">
              <a href="https://drive.google.com/file/d/1VJcFdxKVlOBJpB-pgrPCCSxCkBVuYgG8/view?usp=sharing" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-3 bg-[#0a1628] border border-white/10 rounded-xl px-5 py-4 hover:border-[#38bdf8]/40 hover:bg-[#0a1628]/80 transition-all group" data-id="element-543">
                <div className="flex items-center justify-center w-10 h-10 bg-[#38bdf8]/15 rounded-lg" data-id="element-544">
                  <FileDown className="w-5 h-5 text-[#38bdf8]" data-id="element-545" />
                </div>
                <div data-id="element-546">
                  <span className="text-white font-medium group-hover:text-[#38bdf8] transition-colors" data-id="element-547">
                    Rozbor leteckých nehod
                  </span>
                  <span className="block text-xs text-white/40 mt-0.5" data-id="element-548">
                    PDF dokument
                  </span>
                </div>
              </a>
            </div>
          </div>

          <div className="mt-10 pt-8 border-t border-white/10" data-id="element-549">
            <h3 className="text-sm font-medium text-white/50 uppercase tracking-wider mb-4" data-id="element-550">
              Seminář všeobecného letectví 2026
            </h3>
            <div className="relative w-full aspect-video rounded-xl overflow-hidden border border-white/10" data-id="element-551">
              <iframe src="https://www.youtube.com/embed/sUAyz4Kuayg" title="Seminář všeobecného letectví 2026" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen className="absolute inset-0 w-full h-full" data-id="element-552" />
            </div>
          </div>
        </motion.div>
      </div>
    </div>;
}